import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../hooks/useLanguage';

function JoinComplete() {
    const { t } = useLanguage();
    const navigate = useNavigate();

    return (
        <section className="auth_section">
        <div className="inner gap_32">
            <div className="section_title">
                <h3>{t('sign_up')}</h3>
            </div>
            <div className='join_complete_title'>{t('sign_up_complete')}</div>
            <div className="find_wrap">
                <div className="find_content">
                    <p className="accession_text">{t('sign_up_complete_message')}<br />{t('admin_approval_message')}</p>
                    
                    <div className="password_change_steps" style={{marginTop:"32px"}}>
                        <div className="step_wrap">
                            <button 
                                type="button" 
                                className="default_btn black lg w-100"
                                onClick={() => navigate('/')}
                            >
                                {t('back_to_main')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
    );
    }

export default JoinComplete;